import React from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header';

const HeaderWrapper = ({ children }) => {
  const location = useLocation();

  // Rotas onde o Header não deve aparecer
  const noHeaderRoutes = [
    '/funcionarios',
    '/funcionarios/gerenciar-produtos',
    '/funcionarios/cadastrar-funcionario',
  ];

  // Verifica se a rota atual está na lista
  const shouldRenderHeader = !noHeaderRoutes.some((route) =>
    location.pathname.startsWith(route)
  );

  return (
    <>
      {shouldRenderHeader && <Header />}
      {children}
    </>
  );
};

export default HeaderWrapper;